import React from "react";
import { Link } from "react-router-dom";
const handleRegistration = (e) => {
  console.log("registration will be added");
  e.preventDefault();
};
const handleEmailChange = (e) => {
  console.log(e.target.value);
};
const handlePasswordChange = (e) => {
  console.log(e.target.value);
};

const Register = () => {
  return (
    <div>
      <div className="login-form">
        <div>
          <h2>Create Account</h2>
          <form onSubmit={handleRegistration}>
            <input
              onBlur={handleEmailChange}
              type="email"
              name=""
              id=""
              placeholder="your email"
            />
            <br />
            <input
              onBlur={handlePasswordChange}
              type="password"
              name=""
              id=""
              placeholder="your Password"
            />
            <br />
            <input
              type="password"
              name=""
              id=""
              placeholder="Confirm  Password"
            />
            <br />
            <input type="submit" value="Submit" />
          </form>
          <p>
            Already have an Account? <Link to="./login">Login</Link>
          </p>
          <div>----------or----------</div>
          <br />
          <button className="btn-regular">Google Sign In</button>
        </div>
      </div>
    </div>
  );
};

export default Register;
